export const TRIM_SIZE = {
    TS_6x9: 'TS_6x9',
    TS_8_5x11: 'TS_8_5x11',
    TS_10x8_5: 'TS_10x8_5',
    TS_8x10: 'TS_8x10',
    TS_9_5_8x12: 'TS_9_5_8x12',
    TS_10_5x12: 'TS_10_5x12',
    TS_11x9: 'TS_11x9'
};

export const PAGE_ORIENTATION = {
    LANDSCAPE: 'landscape',
    PORTRAIT: 'portrait'
};

export const LANDSCAPE_PAGE_ORIENTATION = {
    TS_10x8_5: 'TS_10x8_5',
    TS_11x9: 'TS_11x9'
};
export const PORTRAIT_PAGE_ORIENTATION = {
    TS_8_5x11: 'TS_8_5x11',
    TS_6x9: 'TS_6x9',
    TS_10_5x12: 'TS_10_5x12',
    TS_8x10: 'TS_8x10',
    TS_9_5_8x12: 'TS_9_5_8x12'
};

export const DEFAULT_PARENT_DISCIPLINE = {
    id: 'All images',
    name: 'All images'
};

export const OM3P = {
    SEARCH_DATE: 'searchDate',
    ESTIMATED_USERS_COUNT : 'estimatedNumberUsers',
    ISBN : 'assetISBN',
    NO_OF_PAGES : 'noOfPages',
    PAGE_FROM : 'pageFrom',
    PAGE_TO : 'pageTo',
    PAGE_RANGE : 'pageRange',
    RESOURCE_TYPE : 'bookType',
    RESOURCE_TYPE_BOOK : 'EBOOK',
    RESOURCE_TYPE_JOURNAL : 'JOURNAL',
    RESOURCE_TYPE_NEWSPAPER : 'NEWSPAPER',
    RESOURCE_TYPE_WEBSITE : 'WEBSITE',
    RESOURCE_TYPE_IMAGE : 'IMAGE',
    RESOURCE_TYPE_OTHER : 'OTHER',
    RIGHTS_OM : 'OM',
    RIGHTS_3P : 'PearsonRights',
    SOURCE : 'source',
    TITLE : 'title',
    SUB_TITLE : 'subTitle',
    URL : 'url',
    VOLUME_NO : 'volumeEdition',
    YEAR_OF_PUBLICATION : 'publicationYear',
    THIRD_PARTY:'3rd Party Material',
    ORIGINAL_MATERIAL: 'Original Material(OM)',
    CONTENT_TYPE: 'contentType',
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    TYPE: 'type',
    TRIM_SIZE: 'trimSize',
    COLOR: 'resourceColorSetting',
    DESCRIPTION: 'description',
    SINGLE_COLOR: 'SingleColor',
    BLACK_WHITE: 'Black and White',
    FOUR_COLOR: 'Color',
    INSERT_AFTER: 'insertAfter'
};
export const OFFER_DETAILS = {
    TITLE: 'Title :', 
    OFFER_START_DATE: 'Offer Start Date', 
    OFFER_END_DATE: 'Offer End Date', 
    OFFER_STATUS: 'Offer Status', 
    OFFER_TYPE_CODE: 'Offer Type Code', 
    SUBSCRIPTION_DURATION: 'Subscription Duration:', 
    PRODUCT_ID: 'Product Id:', 
    SOURCE_SYSTEM: 'Source System :', 
    DATE_CREATED: 'Date Created:', 
    REPUBLISHED: 'Republished :', 
    OFFER_ID: 'offerId :', 
    PRICE: 'price :',
    CURRENCY: 'currency:',
    ISBN: 'Isbn'
};

export const COURSE_DETAILS = {
    COURSE_ID: 'Course Id :', 
    STUDENT_INVITE_LINK: 'Student Invite Link :', 
    COURSE_NUMBER: 'Course Number :', 
    COURSE_TITLE: 'Course Title :', 
    COURSE_STATUS: 'Course Status :', 
    COURSE_COPY_CODE: 'Course Copy Code :', 
    INSTRUCTOR: 'Instructor', 
    INSTITUTION_NAME: 'Institution Name :', 
    ORGANIZATION_ID: 'Organization Id :', 
    COPYABLE: 'Copyable?', 
    COPY_SOURCE_ID: 'Copy Source Id :', 
    ACTIVE_INSTRUCTOR_COUNT: 'Active Instructor Count :', 
    ACTIVE_STUDENT_COUNT: 'Active Student Count :', 
    COURSE_CREATE_DATE: 'Course Create Date :', 
    COURSE_START_DATE: 'Course Start Date :', 
    COURSE_END_DATE: 'Course End Date :', 
    ADD_NEW_INSTRUCTOR: 'Add New Instructor :'
};



// WEBPACK FOOTER //
// ./src/components/constants/constants.js